"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuationWidgetContextProvider = exports.ValuationWidgetContext = exports.LicensePlateInvalidReason = void 0;
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var ValidationRegex_1 = require("../../Shared/Utility/ValidationRegex");
var Data_1 = require("../Common/Data");
var Types_1 = require("../Types");
var LicensePlateInvalidReason;
(function (LicensePlateInvalidReason) {
    LicensePlateInvalidReason[LicensePlateInvalidReason["Empty"] = 0] = "Empty";
    LicensePlateInvalidReason[LicensePlateInvalidReason["TooLong"] = 1] = "TooLong";
    LicensePlateInvalidReason[LicensePlateInvalidReason["StartsWithSpaceOrDash"] = 2] = "StartsWithSpaceOrDash";
    LicensePlateInvalidReason[LicensePlateInvalidReason["TooManySpecialChars"] = 3] = "TooManySpecialChars";
    LicensePlateInvalidReason[LicensePlateInvalidReason["InvalidCharacter"] = 4] = "InvalidCharacter";
})(LicensePlateInvalidReason = exports.LicensePlateInvalidReason || (exports.LicensePlateInvalidReason = {}));
exports.ValuationWidgetContext = (0, preact_1.createContext)(null);
var normalizeAlphaNumericInput = function (value) { return value.replace(ValidationRegex_1.ValidationRegex.normalizeAlphaNumericInput, "").toUpperCase(); };
var ValuationWidgetContextProvider = function (_a) {
    var children = _a.children, defaultState = _a.defaultState;
    var _b = (0, hooks_1.useState)(defaultState), state = _b[0], setState = _b[1];
    var _c = (0, hooks_1.useState)(false), userHasInteractedWithToggle = _c[0], setUserHasInteractedWithToggle = _c[1];
    function updateValuationMethod(newMethod) {
        if (newMethod !== state.currentValuationMethod && !userHasInteractedWithToggle)
            setUserHasInteractedWithToggle(true);
        setState(function (x) { return (__assign(__assign({}, x), { currentValuationMethod: newMethod })); });
    }
    function toggleValuationMethod() {
        updateValuationMethod(state.currentValuationMethod === Types_1.PublicValuationMethod.YearMakeModelDropdowns
            ? Types_1.PublicValuationMethod.LicensePlate
            : Types_1.PublicValuationMethod.YearMakeModelDropdowns);
    }
    function updateDropdownFromSelectedYear(year) {
        return new Promise(function (res, rej) {
            var _a;
            $.getJSON((_a = state === null || state === void 0 ? void 0 : state.configuration) === null || _a === void 0 ? void 0 : _a.makeEndpoint, { modelYear: year })
                .done(function (makes) {
                setState(function (x) {
                    return __assign(__assign({}, x), { selectionValues: __assign(__assign({}, x.selectionValues), { dropdowns: __assign(__assign({}, x.selectionValues.dropdowns), { makes: makes, models: [] }) }) });
                });
                res();
            })
                .fail(function () { return rej(); });
        });
    }
    function updateDropdownFromSelectedYearAndMake(year, make) {
        return new Promise(function (res, rej) {
            var _a;
            $.getJSON((_a = state === null || state === void 0 ? void 0 : state.configuration) === null || _a === void 0 ? void 0 : _a.modelEndpoint, { modelYear: year, manufacturer: make })
                .done(function (models) {
                setState(function (x) {
                    return __assign(__assign({}, x), { selectionValues: __assign(__assign({}, x.selectionValues), { dropdowns: __assign(__assign({}, x.selectionValues.dropdowns), { models: models }) }) });
                });
                res();
            })
                .fail(function () { return rej(); });
        });
    }
    var resetErrorStateWithNewValue = function (cb) {
        setState(function (x) {
            var newState = __assign(__assign({}, x), { errors: {
                    vin: false,
                    plate: false,
                    yearMakeModel: false
                } });
            if (cb) {
                cb(newState.errors);
            }
            return newState;
        });
    };
    var hasValidVin = function (vin) {
        return (vin === null || vin === void 0 ? void 0 : vin.length) === 17 && !Data_1.invalidVinCharacters.some(function (x) { return vin.includes(x); });
    };
    var hasValidLicensePlate = function (licensePlate) {
        return getLicensePlateInvalidReason(licensePlate) === null;
    };
    var getLicensePlateInvalidReason = function (value) {
        // Validation Rulez
        // - Max 9 chars
        // - Alphanumeric plus
        // - only 1 hyphen or space
        // - isn't blank or just spaces
        // - but only 8 alphanumeric
        // Some states allow spaces and hyphens. PA for example will allow either 1 space or 1 hyphen.
        switch (true) {
            // Don't show validation if empty
            case (value === undefined || value === null) || value.length === 0:
                return LicensePlateInvalidReason.Empty;
            // max length of just alphanumeric
            case normalizeAlphaNumericInput(value).length > 8:
                return LicensePlateInvalidReason.TooLong;
            // can't start with space or dash
            case value.indexOf(' ') === 0 || value.indexOf('-') === 0:
                return LicensePlateInvalidReason.StartsWithSpaceOrDash;
            // can't have more than 1 special char (space, -)
            case (value.match(ValidationRegex_1.ValidationRegex.spaceOrDash) || []).length > 1:
                return LicensePlateInvalidReason.TooManySpecialChars;
            // only alphanumeric or space and hyphen
            case ValidationRegex_1.ValidationRegex.finalLicensePlateRegex.test(value) === false:
                return LicensePlateInvalidReason.InvalidCharacter;
            default:
                return null;
        }
    };
    return (0, preact_1.h)(exports.ValuationWidgetContext.Provider, { value: __assign(__assign({}, state), { getValuationMethod: state.currentValuationMethod, updateValuationMethod: updateValuationMethod, updateDropdownFromSelectedYear: updateDropdownFromSelectedYear, updateDropdownFromSelectedYearAndMake: updateDropdownFromSelectedYearAndMake, toggleValuationMethod: toggleValuationMethod, resetErrorStateWithNewValue: resetErrorStateWithNewValue, hasValidVin: hasValidVin, normalizeAlphaNumericInput: normalizeAlphaNumericInput, hasValidLicensePlate: hasValidLicensePlate, getLicensePlateInvalidReason: getLicensePlateInvalidReason, getShowDropdowns: state.configuration.showDropdowns, userHasInteractedWithToggle: userHasInteractedWithToggle }) }, children);
};
exports.ValuationWidgetContextProvider = ValuationWidgetContextProvider;
